import React, {useState} from 'react';
import EquipmentSection from './EquipmentSection';
import {checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {serviceDescription} from '../../Page/TransactionSummaryPage/Shared/Constants';

const ProgramDetailsDisconnect = ({disconnectedServicesAndEquipments, context, dealType}) => {
  const [showEquipment, setShowEquipment] = useState(false);
  const showComponent = checkSectionValid(disconnectedServicesAndEquipments);
  let disconnectedServices = undefined;
  if (showComponent) {
    const {services} = disconnectedServicesAndEquipments;
    const hasServices = services && Object.keys(services).length > 0;

    if (hasServices) {
      disconnectedServices = services.map((service, idx) => {
        if (service.action == 'disconnect') {
          return (
            <div className='program-details-disconnect__service' key={idx.toString() + service.family}>
              <span className='program-details-disconnect__service--name'>{serviceDescription[service.family]}</span>
              <span className='program-details-disconnect__service--user-name'>{service.userName}</span>
            </div>
          );
        }
      });
      disconnectedServices = disconnectedServices.filter(Boolean);
    }
  }
  return showComponent && (disconnectedServices?.length > 0 || disconnectedServicesAndEquipments.isCustomerNeedToReturnEquipment) ? (
    <div className='program-details-disconnect'>
      {disconnectedServices?.length > 0 ? (
        <div className='program-details-disconnect__services-section'>
          <label className='program-details-disconnect__topic'>
            המוצרים והשירותים שבחרת <span> {dealType === '' ? 'להחזיר' : 'לנתק'}</span>
          </label>
          <div className='content-collapse-container'>{disconnectedServices}</div>
        </div>
      ) : (
        ''
      )}
      <div className='program-details-disconnect__equipment-section'>
        {disconnectedServicesAndEquipments.isCustomerNeedToReturnEquipment &&
        (disconnectedServicesAndEquipments?.services?.length > 0 ||
          disconnectedServicesAndEquipments?.loanedEquipmentKitsWithoutAService?.some((kit) => kit.kitItems?.length > 0)) ? (
          <React.Fragment>
            <label className='program-details-disconnect__topic'>שימו לב</label>
            <p>
              {`עליך להשיב ל${window.Config.brand_Name_HE} את כל ציוד ההתחברות עד ליום
                                        ${setDate(disconnectedServicesAndEquipments.lastDateToReturnEquipment)}
                                        . מזכירים כי איחור בהשבת הציוד יגרור חיוב במלוא מחיר הציוד עבורו, כמפורט `}
              <a href={`https://clm.${window.location.hostname}/?769469`} target="_blank" rel="noopener noreferrer" style={{color: 'blue', textDecoration: 'underline'}}>
                בתעריפון באתר
              </a>
              {'.'}
            </p>
            <button className='program-details-disconnect__equipment-btn' onClick={() => setShowEquipment((prevState) => !prevState)}>
              {'רשימת הציוד שיש להחזיר >>'}
            </button>
            {showEquipment && (
              <EquipmentSection
                disconnectedServicesAndEquipments={disconnectedServicesAndEquipments}
                setShowEquipment={setShowEquipment}
                context={context}
              />
            )}
          </React.Fragment>
        ) : (
          <label className='program-details-disconnect__topic'>כלל הציוד שהיה ברשותך הוחזר</label>
        )}
      </div>
    </div>
  ) : null;
};

function setDate(date = '') {
  let res = '';

  try {
    res = date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2];
  } catch (ex) {
    console.log(`ProgramDetailsDisconnect :: setDate EXCEPTION => ${ex}`);
    res = '';
  }

  return res;
}

export default ProgramDetailsDisconnect;
